export default __webpack_public_path__ + "static/media/p2p-gp-girl.69925b7e.webp";